import { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useFormContext } from 'react-hook-form';

import {
  setDocumentType,
  setErrorOcr,
  setIntentsSearchSign,
  setWayCaptureDocument,
} from '../../../app/store/ocrSlice';
import { setErrorMajestic, setIsLoading, setShowAllowFormats } from '../../../app/store/majesticSlice';
import AllowFormatsModal from '../../../ui/Modals/AllowFormatsModal';
import CustomErrorModal from '../../../ui/Modals/CustomErrorModal';

function InputFile({
  onFileLoaded = () => {},
  handlerPassport = () => {},
  handlerIne = () => {},
  handlerCedula = () => {},
  handlerSetImageSide = () => {},
}) {
  const {
    imageFront,
    intentsSearchSign,
    documentType
  } = useSelector((state) => state.ocr);
  const { showAllowFormats } = useSelector((state) => state.majestic);
  const [existError, setExistError] = useState(false);
  const [dataInputFile, setDataInputFile] = useState({});
  const [selectedDocument, setSelectedDocument] = useState('');
  const fileInputRef = useRef(null);
  const fileReaderRef = useRef(null);

  const {
    getValues,
  } = useFormContext();

  const { t } = useTranslation();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setIntentsSearchSign(0));
    return () => {
      dispatch(setIntentsSearchSign(0));
      // Cancela la lectura si el componente se desmonta
      if (fileReaderRef.current && fileReaderRef.current.readyState === 1) {
        fileReaderRef.current.abort();
        console.log('FileReader cancelado por desmontaje del componente');
      }
    };
  }, [dispatch]);

  const handelShowErrorSignature = () => {
    dispatch(setErrorOcr({ messageFormatted: t('TXT_NOT_FOUND_SIGN_ON_IMAGE') }));
  };

  const onFileChange = (event) => {
    const fileTypesPermit = ['jpg', 'jpeg', 'png', 'pdf'];
    const fileTypesPermitIne = ['jpg', 'jpeg', 'png'];
    const input = event.target;
    const selectedFile = event.target.files[0];
    const fileType = selectedFile?.type.split('/')[1];
    const selectedDocumentType = getValues('documentType');

    input.value = '';

    if (['INE', 'CEDULA'].includes(selectedDocumentType) && !fileTypesPermitIne.includes(fileType)) {
      dispatch(setErrorMajestic({ message: t('TXT_UNSUPPORTED_FILE_TO_INE', { documentType: selectedDocumentType }) }));
      setExistError(true);
      return;
    }

    // Cancelar lectura previa si existe
    if (fileReaderRef.current?.readyState === 1) {
      // alert('fileReaderRef');
      fileReaderRef.current.abort();
    }

    if (!fileTypesPermit.includes(fileType)) {
      dispatch(setErrorMajestic({ message: t('TXT_UNSUPPORTED_FILE') }));
      setExistError(true);
      return;
    }

    console.log('onfilechange', fileType);

    if (typeof selectedFile !== 'undefined') {
      // const selectedDocumentType = getValues('documentType');
      let documentSide = 'imageFront';
      // console.log('documentTypeInputFile', selectedDocumentType);
      // console.log({ documentSide });

      setSelectedDocument(selectedDocumentType);
      dispatch(setWayCaptureDocument('byFile'));
      dispatch(setDocumentType(selectedDocumentType));
      dispatch(setIsLoading(true));

      if (imageFront !== '') {
        documentSide = 'imageReverse';
      }

      // Usar FileReader para obtener el base64 del archivo
      const reader = new FileReader();
      fileReaderRef.current = reader;

      reader.onloadstart = () => {
        console.log('Comenzó la lectura del archivo...');
      };

      reader.onprogress = (event) => {
        if (event.lengthComputable) {
          const percent = Math.round((event.loaded / event.total) * 100);
          console.log(`Progreso: ${percent}%`);
        }
      };

      reader.onload = () => {
        const base64 = reader.result;

        setDataInputFile({
          documentSide,
          imageData: base64,
          fileType,
          selectedDocumentType,
        });
        onFileLoaded({
          documentSide,
          imageData: base64,
          fileType,
          selectedDocumentType,
        });
      };

      reader.onerror = (error) => {
        console.error('Error al leer el archivo:', error);
      };

      reader.onabort = () => {
        console.warn('Lectura cancelada por el usuario.');
      };

      reader.onloadend = () => {
        console.log('Lectura finalizada (éxito o fallo).');
        // handlerSetData();
      };

      // Convierte el archivo a Base64
      reader.readAsDataURL(selectedFile);
    }
  };

  const handleHideFormatsModal = () => {
    // console.log('handleHideFormatsModal')
    dispatch(setShowAllowFormats({ show: false }));
  };

  const handleConfirmAttachment = () => {
    dispatch(setShowAllowFormats({ show: false }));
    fileInputRef.current.click();
  };

  const handleChangeErrorExist = () => {
    setExistError(false);
  };

  const handleGetSignPassport = () => {
    dispatch(setIntentsSearchSign(intentsSearchSign + 1));
  };

  return (
    <>
      <input
        type="file"
        id="directScience_fileInput"
        name="document"
        accept="image/png, image/jpeg, application/pdf"
        style={{ display: 'none' }}
        ref={fileInputRef}
        onChange={onFileChange}
      />
      {showAllowFormats && (
        <AllowFormatsModal
          showModal
          handleConfirmAttachment={handleConfirmAttachment}
          handleHideFormatsModal={handleHideFormatsModal}
        />
      )}
      {existError && <CustomErrorModal handleCloseModal={handleChangeErrorExist} />}
    </>
  );
}

// Asigna el displayName
// InputFile.displayName = 'InputFile';

export default InputFile;
